import { EVENT_FORMAT } from '@/utils/constants';

function isHybrid(event) {
  return event?.format === EVENT_FORMAT.HYBRID;
}


export { isHybrid }